export default __webpack_public_path__ + "static/media/about-me.8f8661f2.png";